import { z } from 'zod';
import { HeldOrgFunctionRefSchema } from '../../entities/org-function/org-function-ref.schema';
/**
 * List My OrgFunctions Request Schema
 * GET /api/v2/orgFunction/mine
 */ export const ListMyOrgFunctionsRequestSchema = z.object({});
/**
 * List My OrgFunctions Response Schema
 * GET /api/v2/orgFunction/mine
 *
 * The current user's held OrgFunctions: their mainRole (the Stelle) first, then
 * their secondary roles plus the OrgFunctions they lead, deduped by orgFunction
 * id. Each row carries `via` marking which link it is held through. Soft-deleted
 * OrgFunctions are resolved here (lookup surface) and carry `deletedAt`.
 */ export const ListMyOrgFunctionsResponseSchema = z.object({
    data: z.array(HeldOrgFunctionRefSchema)
});

//# sourceMappingURL=list-my-org-functions.schema.js.map